/**
 * Making the shadow appear like a document so React events work as normal.
 *
 * I also tested the `react-shadow-dom-retarget-events` package
 * but it doesn't work stable inside Material UI dialogs.
 *
 * Credits:
 * https://github.com/facebook/react/issues/9242#issuecomment-534096832
 * https://github.com/facebook/react/issues/9242#issuecomment-543117675
 */
export function hackShadowRoot(
  mountPoint: HTMLDivElement,
  shadowRoot: ShadowRoot
) {
  Object.defineProperty(mountPoint, "ownerDocument", {
    value: shadowRoot,
  });

  const shadowDocument = shadowRoot as any;

  shadowDocument.createElement = (
    tagName: string,
    options?: ElementCreationOptions | undefined
  ) => document.createElement(tagName, options);

  shadowDocument.createElementNS = (
    namespaceURI: string | null,
    qualifiedName: string,
    options?: ElementCreationOptions
  ) => document.createElementNS(namespaceURI, qualifiedName, options);

  shadowDocument.createTextNode = (data: string) =>
    document.createTextNode(data);

  // Needed for MUI Autocomplete field.
  shadowDocument.defaultView = {
    getComputedStyle: (elt: Element, pseudoElt?: string | null) =>
      window.getComputedStyle(elt, pseudoElt),
  };
}
